module.exports = __webpack_public_path__ + "9e34bccfe7d17f07bfe810968a55c354.MP3";